import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { Col, Row } from "reactstrap";
import { Bar } from 'react-chartjs-2';
import PageTitle from "Layout/Components/PageTitle";
import BoxValue from "./BoxValue";
import { statisticsOrigin } from "API/StatisticsAPI";
import StatisticsOriginTable from "./StatisticsOriginTable";

class StatisticsOrigin extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      today: this.buildData(),
      last7Days: this.buildData(),
      last30Days: this.buildData(),
      last365Days: this.buildData()
    }
  }

  buildData() {
    return {
      total: 0,
      details: []
    };
  }

  componentDidMount() {
    statisticsOrigin().then(result => {
      this.setState({
        data: result.data,
        today: result.data.find(item => item.period === 1),
        last7Days: result.data.find(item => item.period === 7),
        last30Days: result.data.find(item => item.period === 30),
        last365Days: result.data.find(item => item.period === 365)
      });
    }).catch((error) => {
      console.error("Error fetching statistics data:", error);
    });
  }

  render() {
    const { t, i18n } = this.props;

    const { data, today, last7Days, last30Days, last365Days } = this.state;

    const buildGraphOptions = () => {
      return {
        maintainAspectRatio: true,
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        }
      };
    }

    const getRandomColor = () => {
      const r = Math.floor(Math.random() * 200);
      const g = Math.floor(Math.random() * 200);
      const b = Math.floor(Math.random() * 200);
      return `rgba(${r}, ${g}, ${b}, 0.7)`;
    };
    
    const originTotals = {};
    data.forEach(entry => {
      (entry.details || []).forEach(d => {
        originTotals[d.origin] = (originTotals[d.origin] || 0) + d.total;
      });
    });
    const sortedOrigins = Object.keys(originTotals).sort((a, b) => originTotals[b] - originTotals[a]);

    const datasets = sortedOrigins.map(origin => {
      return {
        label: origin,
        data: data.map(entry => {
          const detail = (entry.details || []).find(d => d.origin === origin);
          return detail ? detail.total : 0;
        }),
        backgroundColor: getRandomColor()
      };
    });

    const graphData = {
      labels: [t("statistics.today"), t("statistics.last-7-days"), t("statistics.last-30-days"), t("statistics.last-2-years")],
      datasets: datasets
    }

    return (
      <Fragment>
        <PageTitle
          heading={t("statistics.origin.title")}
          icon="pe-7s-graph2 icon-gradient bg-primary"
        />
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}>
          <Row>
            <Col md="3">
              <BoxValue heading={t("statistics.today")} value={today.total} />
            </Col>
            <Col md="3">
              <BoxValue heading={t("statistics.last-7-days")} value={last7Days.total} />
            </Col>
            <Col md="3">
              <BoxValue heading={t("statistics.last-30-days")} value={last30Days.total} />
            </Col>
            <Col md="3">
              <BoxValue heading={t("statistics.last-2-years")} value={last365Days.total} />
            </Col>
          </Row>
          <Row>
            <Col md="12">
              {/* <div className="text-center">
                <h5>{t("statistics.new-users")}</h5>
              </div> */}
              <Bar data={graphData} options={buildGraphOptions()} height={100}/>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <StatisticsOriginTable data={data} />
            </Col>
          </Row>
          
        </CSSTransitionGroup>
      </Fragment>
    )
  }
}

export default withTranslation()(StatisticsOrigin);